<div class="iframe-container">
  <iframe title="Iframe" [src]="sanitizedUrl" [width]="width" [height]="height"></iframe>
</div>
